import { Component, inject, input, signal, computed, OnInit } from '@angular/core';
import { SlaughterhouseItem, SlaughterhouseItemAuditTrailItem } from '@hjc/masterdata-types';
import { AuditTrailService } from '@services/audit-trail.service';
import { PartnersService } from '@services/partners.service';
import { AuditTrailComponent } from '@components/audit-trail/audit-trail.component';
import { PageHeaderComponent } from '@components/page-header/page-header.component';
import { InfoComponent, InfoField } from '@components/info/info.component';
import { ProductsAndFillspotsComponent } from '../components/products-and-fillspots/products-and-fillspots.component';

@Component({
  selector: 'md-view-slaughterhouse-details',
  imports: [AuditTrailComponent, PageHeaderComponent, InfoComponent, ProductsAndFillspotsComponent],
  templateUrl: './view-slaughterhouse-details.component.html',
  styleUrl: './view-slaughterhouse-details.component.scss',
  standalone: true
})
export class ViewSlaughterhouseDetailsComponent implements OnInit {
  private partnersService = inject(PartnersService);
  private auditTrailService = inject(AuditTrailService);

  slaughterHouseData = signal<SlaughterhouseItem | undefined>(undefined);
  auditTrail = signal<SlaughterhouseItemAuditTrailItem[]>([]);

  slaughterhouseId = input.required<string>();

  infoFields = computed<InfoField[]>(() => [
    { key: 'id', labelKey: 'FIELDS.IDENTIFIER', type: 'string' },
    { key: 'address', labelKey: 'FIELDS.STREET_ADDRESS', type: 'string' },
    { key: 'zip', labelKey: 'FIELDS.POSTAL_CODE', type: 'string' },
    { key: 'city', labelKey: 'FIELDS.CITY', type: 'string' },
    { key: 'createdAt', labelKey: 'FIELDS.SYSTEM.CREATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'createdBy', labelKey: 'FIELDS.SYSTEM.CREATED_BY', type: 'string' },
    { key: 'updatedAt', labelKey: 'FIELDS.SYSTEM.UPDATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'updatedBy', labelKey: 'FIELDS.SYSTEM.UPDATED_BY', type: 'string' }
  ]);

  ngOnInit(): void {
    const id = this.slaughterhouseId();
    if (id) {
      this.loadSlaughterhouse(id);
      this.loadAuditTrail(id);
    }
  }

  private async loadSlaughterhouse(id: string): Promise<void> {
    try {
      const response = await this.partnersService.getSlaughterhouseById(id);
      this.slaughterHouseData.set(response?.data);
    } catch (error) {
      console.error('Error loading slaughterhouse data:', error);
    }
  }

  private async loadAuditTrail(id: string): Promise<void> {
    try {
      const response = await this.auditTrailService.getAuditTrail<SlaughterhouseItemAuditTrailItem>('slaughterhouse', id);
      this.auditTrail.set(response?.data || []);
    } catch (error) {
      console.error('Error loading audit trail:', error);
    }
  }
}
